export enum EBayEGDError {
  NOT_FOUND = "NOT_FOUND",
  INVALID_URL = "INVALID_URL",
  INVALID_CODE = "INVALID_CODE",
}
